export type RunStatus =
  | 'initial'
  | 'queued'
  | 'in_progress'
  | 'requires_action'
  | 'cancelling'
  | 'cancelled'
  | 'failed'
  | 'completed'
  | 'expired';

export function isRunCompleted(status: RunStatus): boolean {
  return ['cancelled', 'failed', 'completed', 'expired'].includes(status);
}

export function isRunInProgress(status: RunStatus) {
  return ['queued', 'in_progress', 'requires_action', 'cancelling'].includes(status);
}
